<div class="pv2-channel-modal__backdrop" (click)="feche()"></div>
<section class="pv2-channel-modal" role="dialog" aria-modal="true" aria-labelledby="pv2-channel-modal-title">
  <header class="pv2-channel-modal__header">
    <div>
      <span>Marketplaces</span>
      <h2 id="pv2-channel-modal-title">Preços por canal</h2>
      <p>Configure os preços das opções sem publicar automaticamente.</p>
    </div>
    <button type="button" aria-label="Fechar preços por canal" (click)="feche()">×</button>
  </header>

  <div class="pv2-channel-modal__filter" *ngIf="filtroOpcaoId">
    <span><i class="fa fa-filter" aria-hidden="true"></i> Exibindo somente: <strong>{{ opcaoNome || ('Opção #' + filtroOpcaoId) }}</strong></span>
    <button type="button" (click)="removaFiltro()">Ver todas as opções</button>
  </div>

  <div class="pv2-channel-modal__body">
    <p class="pv2-channel-modal__loading" *ngIf="carregando"><i class="fa fa-spinner fa-spin" aria-hidden="true"></i> Carregando preços…</p>
    <div class="pv2-channel-modal__error" *ngIf="erro" role="alert">
      <span>{{ erro }}</span><button type="button" (click)="carregue()">Tentar novamente</button>
    </div>
    <p class="pv2-channel-modal__empty" *ngIf="!carregando && !erro && !canais.length">Nenhum canal de venda cadastrado para este catálogo.</p>

    <div class="pv2-price-matrix" *ngIf="canais.length && opcoesTabela().length">
      <table>
        <thead>
          <tr>
            <th>Opção</th>
            <th><span class="pv2-price-matrix__local">MeuCardápio</span></th>
            <th *ngFor="let linha of canais">
              <div class="pv2-channel__identity">
                <img *ngIf="logoCanal(linha.canal.plataforma) as logo" [src]="logo"
                     [alt]="nomeMarketplace(linha.canal.plataforma)">
                <span *ngIf="!logoCanal(linha.canal.plataforma)" class="pv2-channel__logo-fallback">
                  {{ nomeMarketplace(linha.canal.plataforma).charAt(0) }}
                </span>
                <div>
                  <small class="pv2-channel__marketplace">{{ nomeMarketplace(linha.canal.plataforma) }}</small>
                  <strong>{{ linha.canal.nome }}</strong>
                  <small [class.is-active]="linha.canal.ativo">{{ linha.canal.ativo ? 'Canal ativo' : 'Canal inativo' }}</small>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let opcao of opcoesTabela()">
            <th>{{ opcao.nome }}</th>
            <td class="pv2-price-matrix__base">{{ opcao.precoCatalogo | currency:'BRL':'symbol':'1.2-2':'pt' }}</td>
            <td *ngFor="let linha of canais">
              <ng-container *ngIf="opcaoNoCanal(linha, opcao.opcaoId) as preco; else opcaoAusente">
                <label>
                  <span class="sr-only">Preço de {{ opcao.nome }} em {{ linha.canal.nome }}</span>
                  <input type="number" min="0" step="0.01" [(ngModel)]="preco.valor"
                         (ngModelChange)="marquePreco(linha, preco)" [disabled]="!linha.canal.ativo || linha.salvando">
                </label>
                <div class="pv2-price-matrix__rule" *ngIf="precoForaDaRegra(linha, preco)">
                  <button type="button" (click)="useConfiguracaoCanal(linha, preco)" [disabled]="linha.salvando">
                    Usar regra do canal
                  </button>
                  <span kendoPopoverAnchor [popover]="regraCanal" showOn="click">
                    <button type="button" class="pv2-price-matrix__info" aria-label="Entenda a regra de preço do canal">
                      <i class="fa fa-info-circle" aria-hidden="true"></i>
                    </button>
                  </span>
                  <kendo-popover #regraCanal [width]="300" position="bottom">
                    <ng-template kendoPopoverTitleTemplate>Regra de preço do canal</ng-template>
                    <ng-template kendoPopoverBodyTemplate>
                      <p *ngIf="linha.canal.percentualPrecoPadrao == null" class="mb-1">
                        Este canal usa o mesmo preço do MeuCardápio:
                        <strong>{{ preco.precoCatalogo | currency:'BRL':'symbol':'1.2-2':'pt' }}</strong>.
                      </p>
                      <p *ngIf="linha.canal.percentualPrecoPadrao != null" class="mb-1">
                        A regra aplica {{ ajustePercentual(linha) }} sobre
                        {{ preco.precoCatalogo | currency:'BRL':'symbol':'1.2-2':'pt' }}, resultando em
                        <strong>{{ precoPelaRegra(linha, preco) | currency:'BRL':'symbol':'1.2-2':'pt' }}</strong>.
                      </p>
                      <small>Ao usar a regra, o preço acompanhará futuras alterações do MeuCardápio e do percentual do canal.</small>
                    </ng-template>
                  </kendo-popover>
                </div>
                <small class="pv2-channel__option-error" *ngIf="preco.erro">{{ preco.erro }}</small>
              </ng-container>
              <ng-template #opcaoAusente><span class="pv2-price-matrix__missing">Não disponível</span></ng-template>
            </td>
          </tr>
        </tbody>
      </table>
      <footer>
        <span>As alterações ficarão pendentes para a próxima publicação.</span>
        <button type="button" [disabled]="salvando() || !temAlteracoes()" (click)="salveTudo()">
          <i class="fa" [class.fa-save]="!salvando()" [class.fa-spinner]="salvando()" [class.fa-spin]="salvando()" aria-hidden="true"></i>
          {{ salvando() ? 'Salvando…' : 'Salvar preços' }}
        </button>
      </footer>
    </div>
    <p class="pv2-channel-modal__empty" *ngIf="canais.length && !opcoesTabela().length">Esta opção não foi encontrada nos canais.</p>
  </div>
</section>
